<template>
  <section class="bg-gray-100" id="faq">
    <div class="mx-auto flex max-w-7xl flex-col gap-12 px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <!-- Header -->
      <div class="mx-auto flex w-full max-w-[720px] flex-col items-center gap-3 text-center">
        <span class="text-sm font-semibold uppercase tracking-wider text-primary-600">FAQ</span>
        <h2 class="text-pretty text-3xl font-semibold tracking-[-0.4px] text-gray-950 sm:text-4xl sm:tracking-[-0.72px] lg:text-balance">
          Questions we get before people sign up
        </h2>
      </div>

      <!-- Accordion -->
      <div class="mx-auto w-full max-w-[800px]">
        <Accordion
          type="single"
          class="flex flex-col gap-4"
          :default-value="faqItems[0].value"
          collapsible
        >
          <AccordionItem
            v-for="item in faqItems"
            :key="item.value"
            :value="item.value"
            class="rounded-2xl border border-gray-300 bg-gray-100 px-6 shadow-[inset_0px_-3px_0px_0px_rgba(16,24,40,0.04)] data-[state=open]:bg-white"
          >
            <AccordionTrigger class="group gap-6 py-6 hover:no-underline">
              <p class="flex-1 text-start text-base font-semibold text-gray-950 sm:text-lg">
                {{ item.question }}
              </p>
              <template #icon>
                <Plus class="size-5 shrink-0 text-gray-500 group-data-[state=open]:hidden" />
                <Minus class="hidden size-5 shrink-0 text-gray-500 group-data-[state=open]:block" />
              </template>
            </AccordionTrigger>
            <AccordionContent class="pb-6 pt-0 text-base text-gray-800">
              {{ item.answer }}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/Components/ui/accordion";
import { Plus, Minus } from "lucide-vue-next";

const faqItems = [
  {
    value: "faq-1",
    question: "Can I white-label the editor?",
    answer:
      "Yes, on the Platform plan. Your logo, colours, fonts and domain. Your users never see Designer Tool branding unless you want them to.",
  },
  {
    value: "faq-2",
    question: "Which mail APIs does the exported HTML work with?",
    answer:
      "Lob and PostGrid today, with merge syntax exported in each provider's format. Direct Mail Manager and Shopify connect through our integrations. Any press that accepts HTML at 300 DPI can print the export.",
  },
  {
    value: "faq-3",
    question: "How do merge fields map to my CSV or API?",
    answer:
      "You declare the field names when you mount the editor. They appear in the merge picker and export as merge variables, so a column called first_name becomes {{first_name}} in the HTML.",
  },
  {
    value: "faq-4",
    question: "Can users upload their own fonts and images?",
    answer:
      "Yes. Images are checked for print resolution at the placed size. Fonts can be uploaded as WOFF2 or picked from Google Fonts, and are embedded in the export.",
  },
  {
    value: "faq-5",
    question: "Is there a per-postcard fee?",
    answer:
      "No. Plans are flat monthly or yearly. Postage and printing are billed by your mail provider, not by us.",
  },
  {
    value: "faq-6",
    question: "Where is data stored?",
    answer:
      "Designs and uploads are stored in the EU or US region you pick at signup. With the S3 add-on, assets live in your own bucket.",
  },
];
</script>
